<div class="ivd">
    <div class="ivd__grid">

      @for (key of SLOT_KEYS; track key) {
        <div class="ivd__col">

          <!-- Top bar: slot label + actions menu -->
          <div class="ivd__bar">
            <span class="s26-label">{{'verification.id.documentType.' + SLOT_CONFIGS[key].apiType | translate}}</span>

            <input #fileInput type="file" accept="image/*" style="display:none"
                   (change)="uploadDocument(key, $event)" />

            <itfg-mat-tab-menu class="ivd__menu-btn">
              <div trigger>
                <mat-icon>more_horiz</mat-icon>
              </div>
              <div content>
                <button mat-menu-item (click)="fileInput.click()">
                  <mat-icon>upload</mat-icon><span>{{'verification.id.documentActions.upload' | translate}}</span>
                </button>
                <button mat-menu-item [disabled]="!selectedDocs[key]" (click)="downloadDocument(key)">
                  <mat-icon>download</mat-icon><span>{{'verification.id.documentActions.download' | translate}}</span>
                </button>
                <button mat-menu-item [disabled]="!selectedDocs[key]" (click)="rotateDocument(key, true)">
                  <mat-icon>rotate_right</mat-icon><span>{{'verification.id.documentActions.rotateClockwise' | translate}}</span>
                </button>
                <button mat-menu-item [disabled]="!selectedDocs[key]" (click)="rotateDocument(key, false)">
                  <mat-icon>rotate_left</mat-icon><span>{{'verification.id.documentActions.rotateCounterClockwise' | translate}}</span>
                </button>
                <button mat-menu-item [disabled]="!selectedDocs[key]" (click)="deleteDocument(key)">
                  <mat-icon color="warn">delete</mat-icon><span class="ivd__action--danger">{{'verification.id.documentActions.delete' | translate}}</span>
                </button>
              </div>
            </itfg-mat-tab-menu>
          </div>

          <!-- Document viewer -->
          <div class="ivd__viewer-wrap">
            <itfg-identity-document-viewer
              [client]="client"
              [label]="SLOT_CONFIGS[key].label"
              [documentType]="SLOT_CONFIGS[key].apiType"
              [selectedDocId]="detail?.[SLOT_CONFIGS[key].docKey] ?? null"
              (documentSelected)="onDocumentSelected(key, $event)"
              [docList]="docList"
              [loading]="loadingDocList || detail === undefined"
              [loadingList]="loadingDocList"
              >
            </itfg-identity-document-viewer>
          </div>

          <!-- Bottom bar: status chip + invalidation reason -->
          <div class="ivd__bar">
            @if (detail !== undefined) {
              <mat-menu #invalidMenu="matMenu" xPosition="after">
                <div class="s26-menu-header">{{'verification.id.documentActions.invalidate.label' | translate}}</div>
                @for (reason of INVALIDATION_REASONS; track reason) {
                  <button mat-menu-item (click)="invalidateDocument(key, reason)">
                    <span> {{'verification.id.documentActions.invalidate.' + reason | translate}} </span>
                  </button>
                }
              </mat-menu>
  
              <div class="s26-chip ivd__status-chip--{{ slotStatusClass(key) }}"
                   [class.s26-chip--actionable]="isActionable(key)"
                   [matMenuTriggerFor]="isActionable(key) ? invalidMenu : null"
                   [matTooltip]="isActionable(key) ? 'Инвалидирай' : null"
                   matTooltipPosition="above">
                {{'verification.id.documentStatus.' + slotStatusLabel(key) | translate}}
                @if (isActionable(key)) {
                  <mat-icon>arrow_drop_down</mat-icon>
                }
              </div>
  
              @if (slotReason(key)) {
                <div class="ivd__reason">
                  {{'verification.id.documentActions.invalidate.' + slotReason(key) | translate}}
                </div>
              }
            }@else {
              <div class="s26-skeleton s26-skeleton--text"></div>
            }
          </div>

        </div>
      }

    </div>
</div>